import { render, staticRenderFns } from "./discountList.vue?vue&type=template&id=52fedcac&scoped=true"
import script from "./discountList.vue?vue&type=script&lang=js"
export * from "./discountList.vue?vue&type=script&lang=js"
import style0 from "./discountList.vue?vue&type=style&index=0&id=52fedcac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fedcac",
  null
  
)

export default component.exports